import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';

class CompaniesWithoutActiveSubscriptions extends Component {
	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		const style = {position: 'sticky', top: 0, background: 'white'};
		const data = this.props.viewer.missionControlData.companiesWithoutActiveSubscriptions;

		return (
			<div className="mission-control-list">
				<h1>Companies Without Active Subscriptions</h1>
				<div>Showing {data.length} companies</div>
				<table>
					<tbody>
						<tr>
							<th style={style}>Id</th>
							<th style={style}>Name</th>
							<th style={style}>Tier</th>
							<th style={style}>Created At</th>
							<th style={style}>Updated At</th>
							<th style={style}>Last Session Date</th>
							<th style={style}>Is Sage PSA Company</th>
						</tr>
						{data.map(company => (
							<tr key={company.companyId}>
								<td>{company.companyId}</td>
								<td>
									{company.salesforceAccountId ? (
										<a
											href={`https://forecasttechnologies.lightning.force.com/lightning/r/Account/${company.salesforceAccountId}/view`}
											target="_blank"
											rel="noopener noreferrer"
										>
											{company.name}
										</a>
									) : (
										company.name
									)}
								</td>
								<td>{company.tier}</td>
								<td>{company.createdAt}</td>
								<td>{company.updatedAt}</td>
								<td>{company.lastSessionDate}</td>
								<td>{company.isSagePSACompany ? 'Yes' : 'No'}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}
}

const companiesWithoutActiveSubscriptionsQuery = graphql`
	query companiesWithoutActiveSubscriptions_Query {
		viewer {
			actualPersonId
			component(name: "control_companies_without_active_subscriptions")
			...companiesWithoutActiveSubscriptions_viewer
		}
	}
`;

export {companiesWithoutActiveSubscriptionsQuery};

export default createFragmentContainer(withRouter(CompaniesWithoutActiveSubscriptions), {
	viewer: graphql`
		fragment companiesWithoutActiveSubscriptions_viewer on Viewer {
			id
			actualPersonId
			missionControlData {
				id
				companiesWithoutActiveSubscriptions {
					id
					companyId
					name
					tier
					createdAt
					updatedAt
					lastSessionDate
					isSagePSACompany
					salesforceAccountId
				}
			}
		}
	`,
});
